export var ProjectType;
(function (ProjectType) {
    ProjectType["BOT_TELEGRAM"] = "bot-telegram";
    ProjectType["BOT_DISCORD"] = "bot-discord";
    ProjectType["BOT_SLACK"] = "bot-slack";
    ProjectType["APP_WEB"] = "app-web";
    ProjectType["APP_CROSS_PLATFORM"] = "app-cross-platform";
    ProjectType["APP_WINDOWS"] = "app-windows";
    ProjectType["APP_MACOS"] = "app-macos";
    ProjectType["APP_LINUX"] = "app-linux";
    ProjectType["APP_ANDROID"] = "app-android";
    ProjectType["APP_IOS"] = "app-ios";
})(ProjectType || (ProjectType = {}));
const projects = {
  "ancillapp": {
    "name": "Ancillapp",
    "description": "A PWA to consult journals, songs, prayers, and breviary of the FFB.",
    "link": "https://ancill.app",
    "source": "https://github.com/Ancillapp/ancillapp",
    "type": "app-web",
    "languages": [
      "TypeScript",
      "SCSS"
    ],
    "frameworks": [
      "Lit"
    ],
    "api": [
      "REST",
      "Node.js",
      "Firebase Functions"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "0505030303030505000008080F0F1F1FA0A0C0C0C0C0A0A000000000F0F0F0F007070101010101010101010100000000E0E0808080808080C0C0C0C0C0C0C0C0",
        "colors": [
          "#557892",
          null,
          null
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%235d7f97' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='white' d='M128.5 167.5l-43-41 39-41 43 41zm9-91l-1 3-2 2-3 3-4 1h-4l-4-1-3-2-3-2-1-3-1-4 1-3 2-2 3-2 4-1 4-1 4 1 4 2 2 2 2 3z'/%3e%3cpath fill='white' d='M136.5 216.5l-4-1-3-4-4-7-3-9-2-10-1-11v-9l1-8 2-5 3-2 4 1 3 5 4 6 3 9 2 11 1 10v9l-1 8-3 5z'/%3e%3cpath fill='white' d='M158.7 114l-62.1-9.2 28 48.5z'/%3e%3cpath fill='%23486e8a' d='M129.5 241.5l-12-7-9-9-7-8-3-8 1-5 4-4 8-1 11 2 12 4 12 7 12 7 9 9 7 8 3 8-1 5-4 4-8 1-11-2-12-4z'/%3e%3cpath fill='%234b708c' d='M99.5 99.5l-8 23-12 20-17 15-19 7h-19l-18-7-14-14-10-19-5-23 2-25 7-23 13-19 15-15 19-8h20l18 8 15 14 10 19 4 23z'/%3e%3cpath fill='white' d='M141.5 206.5l-22-3 4-34 22 3z'/%3e%3cpath fill='%23476e8a' d='M111.5 95.5l68-40 11 19-68 39z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "localui": {
    "name": "LocalUI",
    "description": "A simple UI to interact with real or emulated AWS services (LocalStack, Minio, etc).",
    "link": "https://hub.docker.com/r/dabolus/localui",
    "source": "https://github.com/Dabolus/localui",
    "type": "app-web",
    "languages": [
      "TypeScript"
    ],
    "frameworks": [
      "MUI",
      "React",
      "Remix",
      "Docker"
    ],
    "api": [
      "REST",
      "Node.js"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "000007070808111011103030404080801B009B800000B404B2020202C101C1018080808F404A202F0008000B0008000F010101F102F204F4001000D0001000F0",
        "colors": [
          "#232f3e",
          "#3e3174",
          "#ff9900"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%23dbd5d6' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%230c005b' d='m66.5 123.5 119 2-1 68-119-2z'/%3e%3cpath fill='%23ffb40e' d='m186.5 90.5-11 12-13 10-11 6-10 2-8-2-4-7v-10l3-12 7-15 10-14 11-12 12-10 12-6 10-2 7 2 4 7 1 10-4 13-7 14z'/%3e%3cpath d='m202.9 172.2 22.9-79.6 8 38.6zM34.5 100.5l2 2 1 3 1 5v6l-1 6-1 7-2 5-3 5-2 2-2 1-2-1-2-4v-10l1-7 1-6 2-6 2-4 3-3z'/%3e%3cpath fill='white' d='m-136.5 150.5-1-16 12-24 25-30 34-31 41-31 43-26 42-20 36-13 27-2 15 7 1 16-12 23-25 29-34 32-41 31-43 27-42 20-36 13-27 2z'/%3e%3cpath d='m79.5 75.5-13 13-13 10-10 8-8 5h-3v-3l5-8 8-10 11-12 13-13 13-12 13-11 10-8 7-4 4-1-1 4-4 7-8 10-11 12z'/%3e%3cpath fill='white' d='m246.5 178.5-5-4-4-13-4-19-2-24v-54l3-24 3-19 4-13 5-4 5 4 4 13 3 19 2 24 1 27-1 27-2 24-3 19-5 13z'/%3e%3cpath d='M29.7 152.1 63 174.4l-39.3-56.6z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "chattgb": {
    "name": "ChatTGB",
    "description": "A Telegram bot that allows easy access to OpenAI's APIs (GPT-4, DALL-E, etc.).",
    "link": "https://t.me/ChatTGBBot",
    "source": "https://github.com/Dabolus/telegram-bots/tree/main/bots/chattgb",
    "type": "bot-telegram",
    "languages": [
      "TypeScript"
    ],
    "frameworks": [
      "Serverless",
      "AWS Lambda"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "0007001800100031005200960094009D000000980066008200510069002500A20049002900320052006600390033000C009900990049004A006600BC000800F0",
        "colors": [
          null,
          "#56a6b3",
          null
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%237fbbc5' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%23f0f7f8' d='M144.5 231.4 39.8 187.8l98.1-169.2z'/%3e%3cpath fill='white' d='M137.2 62.4 105 27.5l105.9 30.1zm88.6 87.5-104.2 36 68 13.4z'/%3e%3cpath fill='white' d='m124.6 67.6 55.8 20.2 7.2 107zM53.5 205 25.6 91l81.1 120.5z'/%3e%3cpath fill='%232d91a1' d='M-15.5 221.3 78.4-14.6l-81-.9z'/%3e%3cpath fill='white' d='m30.7 99.1 100-62-37.2-5.4z'/%3e%3cpath fill='%23007388' d='m123.7 85.8-49.9 96.8 35.2-5.7z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "choicest-voice": {
    "name": "The Choicest Voice",
    "description": "A game that challenges the player to imitate the voice of a character.",
    "link": "https://gga.dev/choicest-voice/",
    "source": "https://github.com/Dabolus/web-experiments/tree/main/src/experiments/choicest-voice",
    "type": "app-web",
    "languages": [
      "HTML",
      "SCSS",
      "TypeScript"
    ],
    "frameworks": [
      "Vanilla"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "000007070F0A0F0D0F0A0F0D0F0F080F0000E0E0F0B0F050F0B0F050F0F010F0383FA8AFFFFFA8AF272710100F0F01011CFC15F5FFFF15F5E4E40808F0F08080",
        "colors": [
          "#534f4b",
          "#dcd2cb",
          "#6e9fa0"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%23d8b955' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%2300318d' d='m126.5 115.5-16-3-15-7-11-10-7-12-2-14 3-14 8-12 12-9 15-6 16-1 16 2 14 7 11 10 7 13 2 14-3 13-8 12-12 10-14 5z'/%3e%3cpath fill='%23b8c2ff' d='m126.5 105.5 15 2 13 6 11 8 6 10 2 11-3 11-7 10-11 8-13 4-15 2-15-3-13-5-11-8-7-10-2-11 3-11 7-10 11-8 14-4z'/%3e%3cpath fill='%23ffdb37' d='m61.5 172.5-14 74-20 66-22 51-22 31-21 9-17-15-12-37-5-55 2-68 9-75 14-74 20-65 22-50 22-32 21-8 17 14 12 37 5 54-2 69z'/%3e%3cpath fill='%233d3844' d='m77.5 157.5-30-21 15-23 31 21z'/%3e%3cpath fill='%23ffdb37' d='m263.5 363.5-15-11-17-34-17-55-16-69-12-78-9-79-3-70 2-57 7-38 12-14 15 11 17 34 17 55 16 68 13 78 8 78 3 72-2 57-7 37z'/%3e%3cpath fill='%23ffd83e' d='m107.5 211.5 19 29 14 28 7 25 1 19-6 11-13 3-18-7-21-15-23-21-22-27-18-29-14-28-8-25-1-19 6-11 13-3 18 7 21 15 23 21z'/%3e%3cpath fill='%235c575a' d='m107.5 208.5-10-6-9-7-6-6-3-7v-6l4-4 7-2h9l11 2 11 4 11 6 8 6 7 7 3 7-1 5-4 4-7 3h-9l-11-2z'/%3e%3cpath fill='%23313257' d='m185.5 116.5 6 1 5 3 4 4 3 4v5l-1 5-3 4-5 3-5 2h-7l-6-1-5-3-4-4-3-4v-5l1-5 3-4 5-3 5-2z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "coc-troop-creator": {
    "name": "Clash of Clans Troop Creator",
    "description": "Create your own Clash of Clans troops!",
    "link": "https://clashroyalecardmaker.com/CoCTC",
    "type": "app-web",
    "languages": [
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "frameworks": [
      "Vanilla"
    ],
    "icon": {
      "formats": [
        "jpg",
        "webp",
        "jxl"
      ],
      "pixelart": {
        "bitmap": "07070F087F707F407F407F407F407F40E0E010F00EFE02FE02FE02FE02FE02FE7F407F407F407F403F201F100F0E010102FE02FE02FE02FE04FC18F860E08080",
        "colors": [
          "#ffbe5a",
          "#c80a14",
          "#785a3c"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%233e4526' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%23d99b5d' d='M18.5 134.5l5-5 14-6 23-4 28-3 32-1 32 1 28 3 23 4 14 5 5 6-5 6-14 5-23 4-28 3-32 1-31-1-29-2-23-4-14-6z'/%3e%3cpath fill='%230e231a' d='M-78.5 129.5l-4-14 6-23 16-29 25-33 30-32 32-31 33-24 29-17 23-6 14 4 4 14-6 22-17 30-24 31-30 34-34 30-31 25-30 16-22 7z'/%3e%3cpath fill='%236d6b39' d='M218.5 156.5l-6 2h-6l-6-1-5-4-4-5-2-6-1-6 2-6 3-5 5-4 5-2h6l6 2 5 4 4 4 2 6 1 6-2 6-3 5z'/%3e%3cpath fill='%23aea181' d='M28.5 120.5v14.9l22.8-16z'/%3e%3cpath fill='%230d231a' d='M146.5-100.5l16-4 22 6 26 16 27 24 25 30 21 32 15 32 8 29v23l-9 14-16 4-22-6-26-16-26-24-25-30-22-32-15-32-8-29 1-23z'/%3e%3cpath fill='%230d221a' d='M46.5 196.5l30 33 24 33 16 28 7 22-3 13-14 4-22-8-28-17-32-25-31-30-30-34-25-32-16-29-7-22 4-13 13-3 22 7 28 17 31 25z'/%3e%3cpath fill='%23505a27' d='M135.5 147.5l15 5 13 7 10 9 5 11v10l-5 8-9 7-12 5-15 1-15-2-15-5-13-7-10-10-5-10v-10l5-9 9-7 12-4 15-1z'/%3e%3cpath fill='%230c221a' d='M206.5 200.5l26-25 26-19 24-13 18-5 12 3 4 12-4 19-12 24-19 27-23 27-27 24-26 20-23 13-19 5-12-4-4-11 4-19 12-24 19-27z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "cr-card-maker": {
    "name": "Clash Royale Card Maker",
    "description": "Create your own Clash Royale cards!",
    "link": "https://clashroyalecardmaker.com",
    "type": "app-web",
    "languages": [
      "HTML",
      "CSS",
      "JavaScript"
    ],
    "frameworks": [
      "Vanilla"
    ],
    "icon": {
      "formats": [
        "jpg",
        "webp",
        "jxl"
      ],
      "pixelart": {
        "bitmap": "010102037C7F437F5B7E5F745F705F73808040C03EFEC2FEDA7EFA2EFA0EFACE5F7C5F705F734F7C233F101F0E0F0101FA3EFA0EFACEF23EC4FC18F860E08080",
        "colors": [
          "#ffbe5a",
          "#14466e",
          "#bc7630"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%231c4066' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%23efb973' d='M35.5 125.5l5-7 14-6 22-4 27-3h30l31 1 27 4 22 5 14 6 4 7-4 6-14 6-22 4-28 3-30 1-30-2-28-3-22-5-13-6z'/%3e%3cpath fill='%23a38060' d='M29.5 134.5l-1-6 2-6 4-6 5-4 7-3 7-1 7 1 6 3 4 4 3 6v6l-2 6-3 5-6 5-6 2-7 1-7-1-6-3-5-4z'/%3e%3cpath fill='%23001840' d='M89.5 352.5l-1-16 12-25 24-34 35-39 41-39 44-37 42-30 37-20 27-9 15 3 1 15-12 26-25 33-34 39-42 39-44 37-42 30-36 21-27 9z'/%3e%3cpath fill='%230d539a' d='M182.5 69.5l-2 8-8 10-14 8-18 7-21 4-21 2h-19l-16-4-11-6-4-8 2-9 8-9 14-8 18-7 20-5 21-2 20 1 16 4 10 6z'/%3e%3cpath fill='%2300183f' d='M194.5 49.5l-30-35-24-33-15-31-6-23 4-13 13-3 23 8 28 19 32 27 33 32 29 35 24 34 16 30 6 23-4 14-14 3-23-9-28-18-32-27z'/%3e%3cpath fill='%230f5398' d='M205.5 155.5l-3 8-8 7-15 8-19 7-22 5-22 3-20 1-17-1-11-4-5-6 2-7 9-8 15-8 19-7 22-5 22-3 20-1 17 2 11 4z'/%3e%3cpath fill='%23a0b3cd' d='M182.5 120.5l4-17 18 5-5 16z'/%3e%3cpath fill='%2300163d' d='M58.5 49.5l-44 37-43 31-37 20-29 8-17-4-3-17 11-28 24-36 34-40 42-40 43-38 44-30 38-21 28-8 17 5 3 17-11 27-24 36-34 40z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "dabbext": {
    "name": "Dabbext",
    "description": "A Telegram inline bot to generate funny text effects.",
    "link": "https://t.me/DabbextBot",
    "source": "https://github.com/Dabolus/telegram-bots/tree/main/bots/dabbext",
    "type": "bot-telegram",
    "languages": [
      "TypeScript"
    ],
    "frameworks": [
      "Serverless",
      "AWS Lambda"
    ],
    "icon": {
      "formats": [
        "jpg",
        "webp",
        "jxl"
      ],
      "pixelart": {
        "bitmap": "FF13FF5BFF1BFFFFFF31FFB5FFB1FFFFFF11FF55FF11FFFFFF11FF55FF11FFFFFF13FF5BFF1BFFFFFF31FFB5FFB1FFFFFF31FFB5FFB1FFFFFF13FF5BFF1BFFFF",
        "colors": [
          "#000000",
          null,
          "#0aa532"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%23092309' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%230f5d10' d='M15.5 108.5l5-7 14-7 21-5 26-2h30l29 3 26 5 20 7 13 8 4 8-5 8-13 6-22 5-26 3-29-1-29-2-26-5-21-7-13-8z'/%3e%3cpath fill='%23020103' d='M18.5 233.5l9-21 21-19 33-13 41-7 44-1 44 6 39 13 30 18 19 21 6 22-9 22-21 18-33 13-40 8h-45l-43-6-40-13-30-18-19-21z'/%3e%3cpath fill='%23114713' d='M191.5 205.5l-1 10-2 9-2 7-2 5-3 1-2-2-1-4-1-8v-19l1-10 2-9 2-7 2-4 2-1 2 1 2 5 1 7v9z'/%3e%3cpath fill='%230c430e' d='M251.5 114.5l-3 8-5 7-7 5-8 3-7-1-7-3-6-5-4-7-2-9 1-9 3-8 5-7 7-5 7-3h8l7 3 6 6 4 7 1 9z'/%3e%3cpath fill='%230d300e' d='M122.5 101.5l-38-8-34-16-27-23-15-27-4-28 9-28 21-24 30-17 36-10h40l39 8 34 16 26 23 15 27 4 28-9 28-21 24-30 17-36 10z'/%3e%3cpath fill='%23061307' d='M259.2 128.5l-73.6 27 67.3 116z'/%3e%3cpath fill='%230c280d' d='M139.5 191.5l1-15 3-14 4-11 5-7 5-2 5 2 4 8 3 11 1 14v16l-1 15-3 14-4 11-5 7-5 3-5-3-4-7-3-12-1-14z'/%3e%3cpath fill='%230e5e10' d='M52.5 137.5v-9l33-1v10z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "eudcc-reader": {
    "name": "EUDCC Reader",
    "description": "A web-based EUDCC (aka Green Pass) reader and verifier.",
    "link": "https://gga.dev/eudcc-reader/",
    "source": "https://github.com/Dabolus/web-experiments/tree/main/src/experiments/eudcc-reader",
    "type": "app-web",
    "languages": [
      "TypeScript",
      "SCSS Modules"
    ],
    "frameworks": [
      "Preact"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "33336161F7F7BFBF1F193F39BFBFFFFFCCCC8686EFEFFDFDF8F8FCFCFDFDFFFFFFFFBFBF3F3F1F1FBFBFF7F761613333FFFFFDFDFCDCF8F8FDFDEFEF8686CCCC",
        "colors": [
          "#335984",
          null,
          "#ffffff"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%23a2a3a4' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%234e4d4c' d='m77.5 205.5 1-11 4-10 6-8 7-5 8-1 9 1 7 5 6 8 4 10 1 10-1 11-4 10-6 8-7 5-8 1-9-1-7-5-6-8-4-10z'/%3e%3cpath d='m138.1 61.8-30.6 21.7-9-20z'/%3e%3cpath fill='white' d='m255.5-67.5 4 11 4 30 3 46 2 60v66l-1 65-2 60-3 47-4 30-4 11-4-11-4-30-3-47-2-60v-65l1-66 2-60 3-46 4-30z'/%3e%3cpath fill='white' d='m162.5 242.5 52 1 47 3 37 4 24 4 8 4-8 4-24 2-37 2-47 1h-52l-52-2-47-3-37-4-23-4-8-4 8-3 24-3 37-2 47-1z'/%3e%3cpath fill='%23204b7b' d='m107.5 117.5 3-4 7-1h9l10 3 11 5 9 6 9 6 5 7 3 6-1 5-3 4-7 1h-9l-10-3-11-5-9-6-9-6-5-7-3-6z'/%3e%3cpath fill='white' d='M18.4-15.1 131.3.3-12 20.4z'/%3e%3cpath fill='%23353330' d='m213.5 181.5 10 17 9 17 5 14 1 10-3 6h-6l-9-5-11-10-12-14-12-16-11-17-8-17-5-14-1-10 2-6h6l9 5 12 10 12 14z'/%3e%3cpath fill='%232c2b2a' d='m69.5 106.5-2 10-5 8-6 6-8 4-9 1-8-2-7-5-5-8-3-9-1-9 2-10 5-8 6-6 8-4 8-1 9 2 7 5 5 8 3 9z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "google-assistant-desktop": {
    "name": "Google Assistant Desktop",
    "description": "A desktop version for the Google Assistant.",
    "link": "https://github.com/Dabolus/google-assistant-desktop-unofficial/releases/latest",
    "source": "https://github.com/Dabolus/google-assistant-desktop-unofficial",
    "type": "app-cross-platform",
    "languages": [
      "TypeScript",
      "SCSS"
    ],
    "frameworks": [
      "Electron",
      "Lit",
      "Redux"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "00001C1C3E3E7F7F7F7F7F7F3E3E1C1C000000000000000004000030007800780000000000000100010001000000000000300000E000F000F000F000E0000000",
        "colors": [
          "#2887ef",
          "#ea4335",
          "#fbbc05"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%23dcdee0' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath d='M132.5 199.5l-31-2-27-4-22-6-14-6-4-7 5-7 14-5 22-5 27-2h31l30 2 27 4 22 5 14 7 4 6-5 7-14 6-22 4-27 2z'/%3e%3cpath fill='%23004cff' d='M99.5 111.5l-4-5-2-6v-6l1-6 4-5 5-4 6-1h6l6 2 5 4 4 5 2 6v6l-2 6-3 5-5 3-6 2h-6l-6-2z'/%3e%3cpath d='M210.5 195.5v-2l1-1 1-1 2-1 3-1h4l2 1 1 1v2l-1 2-1 1-2 1h-2l-2 1-2-1h-2l-1-1z'/%3e%3cpath fill='white' d='M260.5 198.5l-9 3-10-2-11-7-10-10-9-12-6-14-3-14 1-12 3-10 7-7 9-2 11 2 10 6 11 10 8 13 6 14 3 13v13l-4 10z'/%3e%3cpath d='M121.5 195.5l-28 1h-26l-20-1-13-3-5-5 4-5 12-5 20-5 25-5 28-3 28-2h25l21 2 13 3 5 4-4 6-13 5-19 5-25 4z'/%3e%3cpath fill='%23f07400' d='M140.8 85l-2.7 58.8 19.2-12.5z'/%3e%3cpath fill='white' d='M31.5-39.5l12 12 7 28 2 41-3 52-7 58-12 56-14 51-16 39-16 24-14 7-11-11-8-28-2-43 3-52 7-57 12-57 15-50 15-39 16-24z'/%3e%3cpath fill='white' d='M402.5 91.5l-16 19-34 11-49 2-59-6-63-14-62-22-53-26-40-28-23-27-3-24 15-19 34-11 49-2 59 6 64 14 61 22 53 25 40 28 24 28z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "ooxml-validator": {
    "name": "OOXML Validator",
    "description": "Validate Office Open XML files with MS official validator directly in your browser.",
    "link": "https://gga.dev/ooxml-validator/",
    "source": "https://github.com/Dabolus/web-experiments/tree/main/src/experiments/ooxml-validator",
    "type": "app-web",
    "languages": [
      "TypeScript",
      "SCSS",
      "C#"
    ],
    "frameworks": [
      "Vanilla",
      ".NET"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "0003007F00FF00FF00FE00F000F000F03EC01FE01FE01FE01F001F007F78FFFC00F000F000E000400000000F000F0007F7F4AFACDFDC7F781F001FE01EE038C0",
        "colors": [
          "#107c41",
          "#800600",
          "#d83b01"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%23c39aaf' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%238a0000' d='M38.5 91.5v-8l6-10 11-11 16-12 18-11 20-9 19-6 16-3 11 1 6 4v8l-6 10-11 11-16 12-19 10-19 9-19 7-16 3-11-1z'/%3e%3cpath fill='%23cf4300' d='m166.5 30.5 10-1 11 2 10 7 9 9 8 13 4 13 1 14-2 12-6 10-8 5-10 2-10-2-11-7-9-9-7-13-5-13-1-14 3-12 5-10z'/%3e%3cpath fill='%23334803' d='m111.5 149.5 6-23 11-19 15-15 16-8h17l15 6 12 13 9 19 3 22-1 23-7 23-11 19-15 15-16 8h-16l-16-6-12-13-8-19-4-22z'/%3e%3cpath fill='red' d='m70.5 201.5 4-5 9-4 13-2 17-1 19 1 18 3 17 4 13 5 8 6 2 5-3 5-9 4-14 2h-17l-19-1-18-2-17-5-12-5-9-5z'/%3e%3cpath fill='%23f4eeff' d='M114.5 225.5h56l50 3 40 6 26 8 9 9-9 9-25 9-40 8-50 5-56 2h-56l-50-3-39-6-26-8-9-9 9-9 25-9 39-8 50-5z'/%3e%3cpath fill='%23f4fdff' d='m106.5 15.5-4 13-10 11-17 9-21 7-23 2-24-1-20-5-17-8-11-11-5-12 4-13 10-10 17-9 20-7 23-2 24 1 21 5 17 8 11 10z'/%3e%3cpath fill='%23f5fdff' d='m211.5 44.5-40-11-36-12-28-11-17-10-5-7 8-5 20-1 30 3 37 6 41 8 40 11 36 11 28 12 18 10 5 8-8 5-20 1-31-3-37-6z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "planet-age": {
    "name": "Planet Age",
    "description": "Check how old you are on each planet.",
    "link": "https://gga.dev/planet-age/",
    "source": "https://github.com/Dabolus/web-experiments/tree/main/src/experiments/planet-age",
    "type": "app-web",
    "languages": [
      "TypeScript",
      "SCSS",
      "EJS"
    ],
    "frameworks": [
      "Vanilla"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "00000000001C003E037F0F7F0F7F1F3E0000000C401E001E808CE0E0F8C0F8001F183F003F070F0F2303700020000000F030F0F0E0E0E0E08088000000000000",
        "colors": [
          "#2c4d67",
          "#697900",
          "#ff5200"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%237b85ba' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%239ab9ff' d='m203.5 378.5-8-12-5-31v-48l4-59 8-66 11-65 13-58 13-45 13-28 11-9 8 11 4 32v46l-4 60-7 65-11 65-13 58-14 46-12 29z'/%3e%3cpath fill='%23263619' d='m78.5 209.5-15-17-10-19-3-22 4-20 10-18 15-13 20-8 21-1 21 6 20 12 15 16 9 20 3 21-3 21-10 18-16 13-19 7-22 1-21-5z'/%3e%3cpath fill='%23ff4700' d='m125.5 145.5 30-5 28-4 22-1 15 1 6 3-5 4-13 6-21 7-28 7-30 6-31 5-28 3-22 2-15-1-5-3 4-5 13-6 22-6 27-7z'/%3e%3cpath fill='%23d10' d='m52.5 37.5 13-6 13-3h13l10 4 7 7 3 10v11l-5 11-9 11-11 8-13 7-13 3h-13l-10-4-7-7-3-10v-11l5-11 9-11z'/%3e%3cpath fill='%230071a7' d='m68.5 107.5 3-11 10-10 14-7 18-5h19l19 3 17 6 13 9 8 11 3 11-4 12-9 9-15 8-17 4-20 1-19-3-17-6-13-9-8-11z'/%3e%3cpath fill='%2391bcff' d='M33.5 121.5v62l-4 55-6 44-9 29-10 10-10-10-10-28-8-44-6-55-3-62v-61l4-56 6-43 9-29 10-10 10 10 10 28 8 43 6 55z'/%3e%3cpath fill='%23780000' d='m32.5 87.5 3-2 5-1 6 2 8 2 8 4 7 4 7 5 4 5 2 4v4l-2 2h-5l-7-1-7-3-8-3-8-5-6-5-5-5-2-4z'/%3e%3cpath fill='%2399b6ff' d='m198.5 27.5-7 17-11 13-15 10-16 4-16-2-15-7-11-12-8-15-2-18 2-17 8-16 11-14 14-9 16-4 17 1 14 7 12 12 7 16 3 16z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "portfolio": {
    "name": "Portfolio",
    "description": "My Portfolio!",
    "link": "https://giorgio.garasto.me",
    "source": "https://github.com/Dabolus/portfolio",
    "type": "app-web",
    "languages": [
      "TypeScript",
      "SCSS",
      "EJS"
    ],
    "frameworks": [
      "Vanilla"
    ],
    "api": [
      "REST",
      "Node.js",
      "Firebase Functions"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "07071F1F3F3F7F7F7F7FFFFFFFCEFFBDE0E0F8F8FCFCFEFEFEFEFFFFFF73FFEDFFB5FFCEFFFF7F7F7F7F3F3F1F1F0707FFA1FF6DFFFFFEFEFEFEFCFCF8F8E0E0",
        "colors": [
          "#212121",
          null,
          "#ffffff"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%233d3d3d' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%23c5c5c5' d='m114.5 165.5-29-2-26-5-21-8-13-9-4-11 5-10 13-8 21-7 26-4 29-2 29 3 26 5 21 7 13 10 5 10-5 10-14 9-21 7-26 4z'/%3e%3cpath d='m88.5 159.5 2-6 3-5 3-3 4-2h3l3 2 2 4 1 4-1 6-1 5-2 6-3 5-3 3-4 2h-3l-3-2-2-4-1-4 1-6z'/%3e%3cpath fill='white' d='m206.5 167.5-27-64 13-6 27 64z'/%3e%3cpath d='m34.5 141.5-4 4-3 2-4 2h-4l-3-1-3-2-1-4v-4l1-5 2-4 3-4 4-3 4-2h4l3 1 3 3 1 3v5l-1 4z'/%3e%3cpath fill='%23212121' d='m84.5 193.5-4-9-1-10 1-8 4-8 6-5 8-2h8l8 4 8 6 5 7 4 9 1 10-1 8-4 8-6 5-8 2h-8l-8-4-8-6z'/%3e%3cpath d='M134.9 154.5 112.2 133l23.4-27.1z'/%3e%3cpath fill='%23151515' d='m188.5 190.5-4-2-3-4-2-5-1-7v-7l2-7 3-6 4-5 5-2h4l4 1 4 4 2 6 1 6-1 8-2 6-3 6-4 5-4 2z'/%3e%3cpath d='m180.5 120.5-1 5-2 3-3 3-4 2h-4l-5-1-3-2-3-3-2-4v-4l1-5 2-3 3-3 4-2h4l5 1 3 2 3 3 2 4z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "portfolio-cartridge": {
    "name": "Portfolio Cartridge",
    "description": "My Portfolio, implemented as a retro game.",
    "link": "https://giorgio.garasto.me/cartridges/",
    "source": "https://github.com/Dabolus/portfolio-cartridge",
    "type": "app-web",
    "languages": [
      "C",
      "GBZ80 ASM"
    ],
    "frameworks": [
      "GBDK-2020"
    ],
    "icon": {
      "formats": [
        "gif-pixelated"
      ],
      "pixelart": {
        "bitmap": "00FF7F807FBB7FA27FAA7FBB7F8000FF00FFFE01FEB9FE29FEB9FEA9FE0100FF20FF70FF20FF00FF04FB09F600FF00FF06FF06FF30FF30FF847B02FD08F604F8",
        "colors": [
          "#2a453b",
          "#365d48",
          "#577c44"
        ]
      },
      "placeholder": "data:image/gif;base64,R0lGODdhEAAQAPEAADBoUIbAbAcYIeD4zywAAAAAEAAQAAACNoSPacHtvoQMUtAZYrPMcu1R1weMZpiVz8ooriK8hjTTrw3EsC4fuJJKLYDDhLCXGvQOgcGgAAA7"
    }
  },
  "quote-generator": {
    "name": "Quote Generator",
    "description": "A Telegram bot that turns any message into an inspirational quote.",
    "link": "https://t.me/GenQuoteBot",
    "source": "https://github.com/Dabolus/telegram-bots/tree/main/bots/quote-generator",
    "type": "bot-telegram",
    "languages": [
      "TypeScript"
    ],
    "frameworks": [
      "Serverless",
      "AWS Lambda"
    ],
    "icon": {
      "formats": [
        "jxl",
        "webp",
        "jpg"
      ],
      "pixelart": {
        "bitmap": "22205650101000000D006800000000018606B23280000000A000300000000000000103000703071E061F0C3F1C3B397700008000F080F8781EE603FFE0FFFFFC",
        "colors": [
          "#7f7f7f",
          "#4d433c",
          "#0aa532"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%232d3231' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%23789085' d='m245.5 130.5-6 13-17 12-26 9-32 6-36 1-36-3-32-7-26-10-16-13-5-14 6-13 16-12 26-9 33-6 36-1 36 3 32 7 25 10 16 13z'/%3e%3cpath fill='%23030000' d='M148.5 89.5h-65l-60-6-46-10-30-15-11-16 9-18 30-16 45-13 59-10 65-6 65 1 60 5 47 11 31 13 11 17-10 17-30 17-46 14-59 10z'/%3e%3cpath fill='%23aecab5' d='m63.5 127.5 3-2 11-2 17-1 21-1h23l23 1 21 1 17 2 10 2 4 2-4 2-10 2-17 1-21 1h-46l-21-2-17-1-11-2z'/%3e%3cpath fill='%233c3c49' d='M56.7 183.4 54.1 72.6l-69.6 47.3z'/%3e%3cpath fill='%23100a0b' d='m247.5 214.5 30 22 26 21 19 20 11 15v10l-9 4-19-4-25-9-30-15-32-20-30-21-26-21-19-20-10-15-1-10 10-4 18 3 25 10 30 15z'/%3e%3cpath fill='%231e130f' d='m29.5 246.5-4-13 1-15 6-15 11-13 14-11 17-6 17-2 16 2 13 7 9 11 4 13-1 15-6 15-11 13-14 11-17 6-17 3-16-3-13-7z'/%3e%3cpath fill='%23221d1d' d='m222.5 104.5 14 3 13 2 11 4 6 3 2 3-3 2-7 2-10 1h-14l-14-2-15-2-13-3-10-3-6-3-2-3 2-3 7-1 11-1h13z'/%3e%3cpath fill='%23303849' d='m227.5 205.5-8-1-8-6-7-10-5-13-4-14-1-16 2-13 3-12 6-8 6-3 8 1 8 6 7 10 5 12 4 15 1 15-1 14-4 12-5 7z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "sqipper": {
    "name": "Sqipper",
    "description": "A simple web app that allows to generate SVG-based image placeholders.",
    "link": "https://gga.dev/sqipper/",
    "source": "https://github.com/Dabolus/web-experiments/tree/main/src/experiments/sqipper",
    "type": "app-web",
    "languages": [
      "HTML",
      "SCSS",
      "TypeScript"
    ],
    "frameworks": [
      "Vanilla"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "07070F0B0F081F101F10302F38277D42F0F0F8C8FC84FE02FE021EE27E82FE027F40FF80FF80FFF0FFFFFFFFFFFDFFF0FF03FF07FF0FFF1FFFFFFFFFFFF7FFC3",
        "colors": [
          "#111111",
          "#ff6700",
          "#ffffff"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%23353230' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='white' d='m56 133.8 140.3 32 .3-126.2zm151.2 99-2.7-44.2-102.3 45.6z'/%3e%3cpath fill='%23fffff8' d='m67.3 155.3 45.1-86.2 76.8 73.5z'/%3e%3cpath d='M246-15.5 271.5 249l-74.6 22.5z'/%3e%3cpath fill='white' d='m99 193.5-74.8 18.3 163.3 15.6z'/%3e%3cpath fill='%23fffff6' d='m199 67-64.9 106.4 79.6-64.3z'/%3e%3cpath fill='%23facca8' d='m88.1 97.6 92.2-41 11.8 77.2z'/%3e%3cpath d='M248.1-15.4-15.5 10.7l287 78z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "steganography-toolkit": {
    "name": "Steganography Toolkit",
    "description": "A PWA that allows to easily obfuscate texts and files using steganography.",
    "link": "https://gga.dev/steganography-toolkit/",
    "source": "https://github.com/Dabolus/web-experiments/tree/main/src/experiments/steganography-toolkit",
    "type": "app-web",
    "languages": [
      "TypeScript"
    ],
    "frameworks": [
      "MUI",
      "React"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "E7E7AFAFF0FF273B4F775F6F5F635F633737959557D720E09777D535D737D030CFF3A7BBF0FF0F0F0000DBDB4A4A4B4B937331F179F9E4FC243CBCBC90909090",
        "colors": [
          "#000000",
          "#00c853",
          "#caecff"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%23a3b8af' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%23003e0f' d='m152.5 173.5-10-24-6-23-2-20 3-15 8-8 11-1 14 6 15 13 14 19 13 22 11 24 6 23 2 20-4 14-7 9-11 1-14-7-15-13-15-18z'/%3e%3cpath fill='white' d='m228.5 138.5 2-55 4-50 6-39 8-25 8-9 9 9 7 26 5 38 3 50 1 55-2 56-4 49-6 40-8 25-8 9-9-9-7-25-5-40-3-50z'/%3e%3cpath d='m135.5 174.5-19 3-17 1-14-1-9-2-4-4 3-4 8-6 12-5 17-5 18-4 19-3 17-1 14 1 9 2 4 3-2 5-8 5-13 6-16 5z'/%3e%3cpath fill='white' d='m231.5 128.5-1 6-3 5-6 5-8 4-9 1h-9l-9-2-7-3-4-5-2-6 1-6 3-6 6-4 8-4 9-2h9l9 2 7 4 4 5z'/%3e%3cpath fill='%23003e13' d='m78.5 84.5-11 12-12 10-12 7-10 1-8-2-4-7-1-11 3-12 7-15 9-14 12-12 12-10 12-6 10-2 8 2 4 7 1 11-3 13-7 14z'/%3e%3cpath fill='%23000c00' d='m99.5 27.5 4-3 6-1h7l9 3 9 4 9 5 6 6 5 6 2 6-1 4-3 4-6 1-8-1-8-2-9-4-9-5-7-6-4-7-2-5z'/%3e%3cpath fill='white' d='M-2.5 126.5v-59l2-53 1-41 4-27 4-10 5 10 4 27 3 41 2 53 1 59v58l-2 53-3 42-3 27-5 10-4-10-4-27-2-42-3-53zm223 146-5 3-9-1-11-3-11-7-12-9-10-11-7-11-5-10-1-9 2-6 6-3 9 1 11 3 11 7 11 9 10 11 8 11 5 10 1 9z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "telegram-media-convert": {
    "name": "Telegram Media Convert",
    "description": "A bot that converts Telegram messages from one format to another.",
    "link": "https://t.me/TgMediaConvertBot",
    "source": "https://github.com/Dabolus/telegram-bots/tree/main/bots/telegram-media-convert",
    "type": "bot-telegram",
    "languages": [
      "TypeScript"
    ],
    "frameworks": [
      "Serverless",
      "AWS Lambda"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "0000000003030C0F323D4976647B507F0000C0C020E010F048B804FC02FE0EFE487F546F2B37121F0A0F06070303000032FECAFE2AFEACFCB0F0C0C000000000",
        "colors": [
          "#191919",
          "#333333",
          "#666666"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%23c0550f' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%23001754' d='m27.5 139.5 2-19 12-19 21-16 27-12 30-7 31-1 29 6 24 11 16 15 7 18-2 20-13 19-20 16-27 12-30 7h-31l-29-5-24-11-16-15z'/%3e%3cpath fill='%23002541' d='M99.5 192.5v-5l3-5 5-4 7-3 7-2 8-1 7 1 6 2 4 4 2 4v5l-3 5-5 4-6 3-8 2-8 1-7-1-6-3-4-3z'/%3e%3cpath fill='%23062e30' d='M60.5 155.5v-17l7-17 15-16 20-13 24-10 25-5 25 1 21 6 15 11 8 15 1 16-8 18-14 16-20 13-25 10-25 4h-24l-21-7-16-10z'/%3e%3cpath fill='%23ff7500' d='m116.5 58.5-49 29-48 20-40 11-32-1-18-11-3-21 13-29 26-33 37-35 46-33 49-29 47-20 42-11 31 1 18 11 3 21-12 29-27 34-37 34z'/%3e%3cpath fill='%23ff7200' d='M99.5 263.5h-79l-70-3-57-6-36-9-13-10 12-11 36-11 56-9 70-7 79-3 79-1 71 3 56 7 37 8 13 11-13 11-36 10-56 9-71 7z'/%3e%3cpath fill='%23ff7100' d='m242.5 14.5 60 38 53 37 40 34 22 26 4 17-17 6-34-7-49-17-58-27-63-35-61-37-52-38-40-32-23-27-3-16 16-6 35 6 48 18 59 27z'/%3e%3cpath fill='%23ff6c00' d='m195.5 288.5-13 4-27-6-40-15-47-22-51-28-48-31-43-30-32-27-18-21-3-13 13-4 27 6 39 14 48 23 49 28 50 30 42 30 33 27 18 21z'/%3e%3cpath fill='%23ff6d00' d='m12.5 66.5 5 3 5 8 3 13 3 16 1 18v18l-2 16-3 13-4 9-5 3-5-3-4-8-4-13-2-16v-36l1-16 3-13 4-9z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "win-font-switcher": {
    "name": "Windows Font Switcher",
    "description": "A super-simple tool to change Windows default system font.",
    "link": "https://github.com/Dabolus/WinFontSwitcher/releases/latest",
    "source": "https://github.com/Dabolus/WinFontSwitcher",
    "type": "app-windows",
    "languages": [
      "C#",
      "XAML"
    ],
    "frameworks": [
      ".NET"
    ],
    "icon": {
      "formats": [
        "svg"
      ],
      "pixelart": {
        "bitmap": "000000000F0F1F1F181810107C7C383800001818A4A4BCBC242466660000080810100000787848487B7B4B4B484800001C1C3E3E08083838F0F0C0C000000000",
        "colors": [
          "#0079ce",
          null,
          null
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%232a7ccd' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%23ffffda' d='M137.5 186.5l-3 2-6 1-10-1-12-2-13-3-13-4-12-4-9-5-5-4-1-3 2-2 7-1 10 1 12 2 13 3 13 4 12 4 9 5 5 4z'/%3e%3cpath fill='%23ffffdb' d='M50.5 206.5l-1-4 1-10 3-13 6-17 8-18 8-18 9-15 8-12 6-7 4-2 2 5-1 9-4 14-6 16-7 19-9 17-8 16-8 11-6 7z'/%3e%3cpath fill='%23d8c8b4' d='M143 84l25.3-48 45.9 94.3z'/%3e%3cpath fill='%2300458d' d='M186 96l-14.5 60.4-20.3-133.6z'/%3e%3cpath fill='%23c9bfbd' d='M112.5 145.5l1 9v9l-4 7-5 6-6 4-8 1-7-2-7-5-6-6-4-9-1-8 1-9 3-8 5-6 6-3 8-1 7 2 7 4 6 7z'/%3e%3cpath fill='%23ffffed' d='M200.8 113.4l-14-37.5-6.1 78.9z'/%3e%3cpath fill='%230971d7' d='M54.5 27.5l36-20 34-13 29-8h22l12 7 1 13-9 20-20 23-28 24-33 24-35 19-34 15-29 8h-21l-12-8-2-14 10-19 20-23 26-25z'/%3e%3cpath fill='%23000b54' d='M100.2 132.1l-24.7 19.4 8 19z'/%3e%3c/g%3e%3c/svg%3e"
    }
  },
  "win-xkill": {
    "name": "win-xkill",
    "description": "A porting of the xkill utility to Windows.",
    "link": "https://github.com/Dabolus/win-xkill/releases/latest",
    "source": "https://github.com/Dabolus/win-xkill",
    "type": "app-windows",
    "languages": [
      "C"
    ],
    "icon": {
      "formats": [
        "png",
        "jxl"
      ],
      "pixelart": {
        "bitmap": "FFFFFFCEFFBAFFBFFFCBFFFFFFFFFFFFFFFFFFFFFFDFFF6FFF5FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFDDFFEBFFF7FFEBFFDDFFFF",
        "colors": [
          "#0c0c0c",
          "#00ff00",
          "#f2f2f2"
        ]
      },
      "placeholder": "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3cpath fill='%23040404' d='M0 0h256v256H0z'/%3e%3cg filter='blur(12px)' fill-opacity='.5'%3e%3cpath fill='%23515151' d='M45 5.7l163.8 46-224.3 1z'/%3e%3cpath d='M77.7-15.5L69.5 28l66.2 1z'/%3e%3cpath fill='%23424242' d='M247.5 33.4L157 17.8l-45 36.6zm-26 239.1l-1-2-1-5v-7l1-8 2-10 2-9 2-8 3-7 2-4 3-1 1 2 1 5v7l-1 8-2 10-2 9-2 8-3 7-2 4z'/%3e%3cpath fill='%23646464' d='M241 30l-8.6 11.6-38-9.4z'/%3e%3cpath d='M179.2-13.2L228.4 31l-176-2zM-14.5 7.5l3-2 9-2 12-2 17-1h37l17 1 14 1 8 2 3 2-3 3-8 2-14 1-17 1-18 1h-19l-17-1-12-2-9-2z'/%3e%3cpath d='M2.5.5h10l-5 93h-9z'/%3e%3c/g%3e%3c/svg%3e"
    }
  }
};
export default projects;
